import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class ScrollFunc {
    constructor() {
        this.init();
    }

    init() {
        this.onScroll();
        this.movieScroll();
    }

    onScroll() {}

    movieScroll() {
        const container = document.querySelector(".top__scroller");
        const buttons = [...document.querySelectorAll(".js-moviepn")];
        let contentWidth;
        const movieItem = [...document.querySelectorAll(".movie__item")];

        const setWidth = () => {
            contentWidth = 0;
            movieItem.forEach((el) => {
                const margin = window.innerWidth <= 835 ? 14 : 20;
                contentWidth += el.offsetWidth + margin;
            });
        };

        setWidth();
        window.addEventListener("resize", setWidth);

        buttons.forEach((el) => {
            el.addEventListener("click", () => {
                const dir = el.getAttribute("data-dir") === "prev" ? -1 : 1;

                const oneblock = document.querySelector(".movie__item");
                gsap.to(container, { duration: 0.6, scrollTo: { x: container.scrollLeft + dir * (oneblock.offsetWidth + 20) }, ease: "circ.inOut" });
            });
        });

        container.addEventListener("scroll", () => {
            const progress = container.scrollLeft / (contentWidth - container.offsetWidth);
            if (progress >= 0) {
                document.documentElement.style.setProperty("--movieprogress", `${progress * 100}%`);
            }
        });
    }
}
